<template>
    <div class="table">
        <div class="container" style="width:95%;">
            <el-form ref="form" :model="form"  v-loading="loading" :rules="rules" label-width="230px">
                <el-form-item prop="deptId" label="学校：">
                    <el-select v-model="form.deptId" placeholder="请选择学校" @change="onDeptChange" style="width:230px;">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-divider content-position="left">钉钉考勤信息配置</el-divider>
                <el-form-item prop="attendanceSwitch" label="启用钉钉考勤：">
                    <el-checkbox v-model="form.attendanceSwitch"></el-checkbox>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <el-button :disabled="!form.attendanceSwitch"  :loading="isDingtalkAttendanceConnectLoading"  @click="isDingtalkAttendanceConnect" size="small" type="warning">测试连接钉钉考勤</el-button>
                    <div v-if="form.dingtalkErrorMsg" style="font-size: 12px;color:red">{{ form.dingtalkErrorMsg }}</div>
                    <div v-if="form.DingtalkSuccess" style="font-size: 12px;color:green">{{form.DingtalkSuccess}}</div>
                </el-form-item>
                <el-form-item prop="organizeId" label="考评组织：">
                    <el-cascader  :disabled="!form.attendanceSwitch"
                        style="width: 230px"
                        :options="organizes"
                        v-model="form.organizeId"
                        :props="props"
                        collapse-tags
                        clearable></el-cascader>
                </el-form-item>

                <el-form-item label="考评日期范围：">
                   每学年的上学期是
                   <el-date-picker style="width:140px;" 
                        :disabled="!form.attendanceSwitch"
                        v-model="form.lastStartDate"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">
                    </el-date-picker>到明年
                    <el-date-picker style="width:140px;"
                        :disabled="!form.attendanceSwitch"
                        v-model="form.lastEndDate"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">
                    </el-date-picker>
                    ，
                    下学期是明年的
                    <el-date-picker style="width:140px;"
                        v-model="form.nextStartDate"
                        :disabled="!form.attendanceSwitch"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">
                    </el-date-picker>
                    到
                    <el-date-picker style="width:140px;"
                        v-model="form.nextEndDate"
                        :disabled="!form.attendanceSwitch"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">
                    </el-date-picker>
                </el-form-item>

                <el-form-item prop="calculateTime" label="计算考勤和推送时间：">
                    每月
                    <el-select v-model="form.calculateDay" placeholder="请选择日" style="width: 110px;">
                        <el-option
                            v-for="item in days"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-time-select style="width:140px;"
                        v-model="form.calculateTime"
                        :disabled="!form.attendanceSwitch"
                        :readonly="setReadonly"
                        :picker-options="{
                            start: '01:00',
                            step: '00:15',
                            end: '23:45'
                        }"
                        placeholder="选择时间">
                    </el-time-select>
                </el-form-item>
                
                <el-divider content-position="left">钉钉考勤减分规则</el-divider>
                <div class="info-tip">
                    <el-tooltip class="item" effect="dark" content="配置钉钉考勤的减分规则" placement="top-start">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </div>
                
                <el-table :data="attendanceRules" border style="width: 100%">
                    <el-table-column prop="index" label="序号" width="70" align="center"></el-table-column>
                    <el-table-column prop="type" label="考勤类型" width="120" align="center"></el-table-column>
                    <el-table-column label="扣分规则" align="left">
                        <template slot-scope="scope">
                            达到 
                            <span v-if="scope.row.type == '事假' 
                                        || scope.row.type == '病假' || scope.row.type == '旷工' ">
                                <el-input-number 
                                    v-model="scope.row.count" 
                                    :disabled="!form.attendanceSwitch" 
                                    :min="1" 
                                    :max="100" 
                                    size="small" 
                                    style="width: 120px;"
                                    controls-position="right"
                                    placeholder="请输入次数"></el-input-number> 天以上，
                                    
                            每天扣 <el-input-number 
                                v-model="scope.row.score" 
                                :disabled="!form.attendanceSwitch" 
                                :min="0" 
                                :max="100" 
                                size="small" 
                                style="width: 120px;"
                                controls-position="right"
                                placeholder="扣分值"></el-input-number> 分（不满1天按照1天计算）
                            </span>
                            <span v-else>
                                <el-input-number 
                                    v-model="scope.row.count" 
                                    :disabled="!form.attendanceSwitch" 
                                    :min="1" 
                                    :max="100" 
                                    size="small" 
                                    style="width: 120px;"
                                    controls-position="right"
                                    placeholder="请输入次数"></el-input-number> 次以上，
                            每次扣 <el-input-number 
                                v-model="scope.row.score" 
                                :disabled="!form.attendanceSwitch" 
                                :min="0" 
                                :max="100" 
                                size="small" 
                                style="width: 120px;"
                                controls-position="right"
                                placeholder="扣分值"></el-input-number> 分
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="设置指标" align="center" :show-overflow-tooltip="true" width="130px">
                        <template slot-scope="scope">
                            {{ scope.row.indexLabel }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120" align="center">
                        <template slot-scope="scope">
                            <el-tooltip content="设置指标" placement="top">
                                <el-button type="text" :disabled="!form.attendanceSwitch || !scope.row.enabled" icon="el-icon-setting" @click="handleEdit(scope.row)"></el-button>
                            </el-tooltip>
                            <el-switch
                                v-model="scope.row.enabled"
                                :disabled="!form.attendanceSwitch"
                                active-color="#13ce66">
                            </el-switch>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <span slot="footer" class="dialog-footer" style="text-align:right; margin-top: 20px; display: block;">
                <el-button type="danger" @click="clearConfig()">清空配置</el-button>
                <el-button type="primary" @click="save()">保 存</el-button>
            </span>
        </div>
        <!-- 教职评价、学生评价指标弹出框 -->
        <div v-if="indicatorsDefineVisable">
            <indicatorsDefine ref="indicatorsDefine"></indicatorsDefine>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http'
    import indicatorsDefine from './components/indicatorsDefine.vue'
    import { MessageBox } from 'element-ui'

    export default {
        data(){
            return{
                loading: false,
                isDingtalkAttendanceConnectLoading: false,
                setReadonly: false,
                props: { checkStrictly: true},
                indicatorsDefineVisable: false,

                form:{
                    attendanceSwitch: false,
                    deptId: "", // 学校ID
                    organizeId: "", // 组织ID
                    lastStartDate: "", // 上学期开始日期
                    lastEndDate: "", // 上学期结束日期
                    nextStartDate: "", // 下学期开始日期
                    nextEndDate: "", // 下学期结束日期
                    calculateDay: "", // 计算考勤日期
                    calculateTime: "", // 计算考勤时间
                    
                    // 减分规则 - 保留原有字段用于兼容性
                    leaveCount: "", // 事假次数
                    leaveScore: "", // 事假扣分
                    leaveIndex: "", // 事假指标
                    leaveIndexLabel: "", // 事假指标标签
                    leaveEnabled: false,
                    sickLeaveCount: "", // 病假次数
                    sickLeaveScore: "", // 病假扣分
                    sickLeaveIndex: "", // 病假指标
                    sickLeaveIndexLabel: "", // 病假指标标签
                    sickLeaveEnabled: false,
                    missCardCount: "", // 缺卡次数
                    missCardScore: "", // 缺卡扣分
                    missCardIndex: "", // 缺卡指标
                    missCardIndexLabel: "", // 缺卡指标标签
                    missCardEnabled: false,
                    earlyLeaveCount: "", // 早退次数
                    earlyLeaveScore: "", // 早退扣分
                    earlyLeaveIndex: "", // 早退指标
                    earlyLeaveIndexLabel: "", // 早退指标标签
                    earlyLeaveEnabled: false,
                    absentCount: "", // 旷工次数
                    absentScore: "", // 旷工扣分
                    absentIndex: "", // 旷工指标
                    absentIndexLabel: "", // 旷工指标标签
                    absentEnabled: false,
                    lateCount: "", // 迟到次数
                    lateScore: "", // 迟到扣分
                    lateIndex: "", // 迟到指标
                    lateIndexLabel: "", // 迟到指标标签
                    lateEnabled: false,

                    dingtalkErrorMsg: "",
                    DingtalkSuccess: "",
                },
                days:[],
                // 表格数据
                attendanceRules: [
                    { index: 1, type: "事假", count: 1, score: 1, indexId:"", indexLabel:"", enabled: false, key: "leave" },
                    { index: 2, type: "病假", count: 1, score: 1, indexId:"", indexLabel:"", enabled: false, key: "sickLeave" },
                    { index: 3, type: "缺卡", count: 1, score: 1, indexId:"", indexLabel:"", enabled: false, key: "missCard" },
                    { index: 4, type: "早退", count: 1, score: 1, indexId:"", indexLabel:"", enabled: false, key: "earlyLeave" },
                    { index: 5, type: "旷工", count: 1, score: 1, indexId:"", indexLabel:"", enabled: false, key: "absent" },
                    { index: 6, type: "迟到", count: 1, score: 1, indexId:"", indexLabel:"", enabled: false, key: "late" }
                ],
                depts:[],
                organizes:[],
                rules: {
                    deptId: [
                        { required: true, message: '请选择学校', trigger: 'blur' }
                    ],
                    organizeId: [
                        { required: true, message: '请选择考评组织', trigger: 'blur' }
                    ],
                    calculateTime: [
                        { required: true, message: '请选择计算考勤和推送时间', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
            indicatorsDefine
        },
        created:function () {
            // 初始日列表
            let days = []
            for(let i=0; i<30; i++){
                let day = {}
                day.value = i+1
                day.label = (i+1)+'日'
                days.push(day)
            }
            let day ={}
            day.value = 99
            day.label = '最后一日'
            days.push(day)
            this.days = days
            
            // 获取部门管理
            this.getDeptData()
        },
        methods:{
            // 编辑规则
            handleEdit(data) {
                console.log('编辑规则', data);
                this.indicatorsDefineVisable=true
                this.$nextTick(() => { 
                    this.$refs['indicatorsDefine'].init(this.form.deptId, data)
                })
            },
            // 获取部门管理
            getDeptData(){
                let url  = this.listDeptUrl; 
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                        this.getOrganizes();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 切换学校
            onDeptChange(){
                this.form.dingtalkErrorMsg=""
                this.form.DingtalkSuccess = ""

                this.getData();
                this.getOrganizes();
            },
            // // 获取对应的指标
            // getEvaluate(data){
            //     this.indicatorsDefineVisable=true
            //     this.$nextTick(() => { 
            //         this.$refs['indicatorsDefine'].init(this.form.deptId, data)
            //     })
            // },
            isDingtalkAttendanceConnect(){
                let url  = this.teacherDingtalkAttendanceEvaluateSetIsDingtalkAttendanceConnectUrl;
                let data = {
                    deptId:this.form.deptId
                };

                this.isDingtalkAttendanceConnectLoading = true
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.form.dingtalkErrorMsg = ""
                        this.form.DingtalkSuccess = res.message
                    }else{
                        this.form.dingtalkErrorMsg = res.message
                        this.form.DingtalkSuccess = ""
                    }

                    this.isDingtalkAttendanceConnectLoading = false
                },(err)=>{
                    console.log(err);
                    this.$commonFn.showTip(err,3);
                    this.isDingtalkAttendanceConnectLoading = false
                });
            },
            // 根据条件获取当前界面数据
            getData(){
                this.clear(); // 清空数据
                this.form.attendanceSwitch = false
                let url  = this.teacherDingtalkAttendanceEvaluateSetListUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // 渲染清空数据
                        let resultData=res.data
                        console.log('resultData', resultData)
                        // 渲染有数据值
                        for(let i=0;i<resultData.length;i++){
                            let obj=resultData[i]

                            if(obj.setKey == 'evaluate_switch_key'){ // 启用钉钉考勤
                                if(obj.setVal === '1'){
                                    this.form.attendanceSwitch = true
                                }else{
                                    this.form.attendanceSwitch = false
                                }
                            }else if(obj.setKey == 'evaluate_dept_key'){ // 考评组织 
                                this.form.organizeId = obj.setVal
                            }else if(obj.setKey == 'evaluate_dateRange_key'){ // 考评日期范围
                                let dateRange = JSON.parse(obj.setVal)
                                this.form.lastStartDate = dateRange.lastStartDate
                                this.form.lastEndDate = dateRange.lastEndDate
                                this.form.nextStartDate = dateRange.nextStartDate
                                this.form.nextEndDate = dateRange.nextEndDate
                            }else if(obj.setKey == 'calculate_time_key'){ // 计算考勤和推送时间
                                let resultObj=JSON.parse(obj.setVal)
                                this.form.calculateTime = resultObj.calculateTime
                                this.form.calculateDay = resultObj.calculateDay
                            }else if(obj.setKey == 'rule_config_key'){ // 减分规则配置
                                let resultObj=JSON.parse(obj.setVal)
                                // 保存到原始表单字段（兼容性）
                                this.form.leaveCount = resultObj.leaveCount
                                this.form.leaveScore = resultObj.leaveScore
                                this.form.leaveIndex = resultObj.leaveIndex
                                this.form.leaveIndexLabel = resultObj.leaveIndexLabel
                                this.form.leaveEnabled = resultObj.leaveEnabled
                                this.form.sickLeaveCount = resultObj.sickLeaveCount
                                this.form.sickLeaveScore = resultObj.sickLeaveScore
                                this.form.sickLeaveIndex = resultObj.sickLeaveIndex
                                this.form.sickLeaveIndexLabel = resultObj.sickLeaveIndexLabel
                                this.form.sickLeaveEnabled = resultObj.sickLeaveEnabled
                                this.form.missCardCount = resultObj.missCardCount
                                this.form.missCardScore = resultObj.missCardScore
                                this.form.missCardIndex = resultObj.missCardIndex
                                this.form.missCardIndexLabel = resultObj.missCardIndexLabel
                                this.form.missCardEnabled = resultObj.missCardEnabled
                                this.form.earlyLeaveCount = resultObj.earlyLeaveCount
                                this.form.earlyLeaveScore = resultObj.earlyLeaveScore
                                this.form.earlyLeaveIndex = resultObj.earlyLeaveIndex
                                this.form.earlyLeaveIndexLabel = resultObj.earlyLeaveIndexLabel
                                this.form.earlyLeaveEnabled = resultObj.earlyLeaveEnabled
                                this.form.absentCount = resultObj.absentCount
                                this.form.absentScore = resultObj.absentScore
                                this.form.absentIndex = resultObj.absentIndex
                                this.form.absentIndexLabel = resultObj.absentIndexLabel
                                this.form.absentEnabled = resultObj.absentEnabled
                                this.form.lateCount = resultObj.lateCount
                                this.form.lateScore = resultObj.lateScore
                                this.form.lateIndex = resultObj.lateIndex
                                this.form.lateIndexLabel = resultObj.lateIndexLabel
                                this.form.lateEnabled = resultObj.lateEnabled
                                // 更新表格数据
                                this.updateTableData(resultObj);
                            }
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.$commonFn.showTip(err,3);
                });
            },
            
            // 更新表格数据
            updateTableData(resultObj) {
                // 遍历表格数据，更新对应的值
                this.attendanceRules.forEach(rule => {
                    switch(rule.key) {
                        case 'leave':
                            rule.count = resultObj.leaveCount || 0
                            rule.score = resultObj.leaveScore || 0
                            rule.indexId = resultObj.leaveIndex || ''
                            rule.indexLabel = resultObj.leaveIndexLabel || ''
                            rule.enabled = resultObj.leaveEnabled
                            break
                        case 'sickLeave':
                            rule.count = resultObj.sickLeaveCount || 0
                            rule.score = resultObj.sickLeaveScore || 0
                            rule.indexId = resultObj.sickLeaveIndex || ''
                            rule.indexLabel = resultObj.sickLeaveIndexLabel || ''
                            rule.enabled = resultObj.sickLeaveEnabled
                            break
                        case 'missCard':
                            rule.count = resultObj.missCardCount || 0
                            rule.score = resultObj.missCardScore || 0
                            rule.indexId = resultObj.missCardIndex || ''
                            rule.indexLabel = resultObj.missCardIndexLabel || ''
                            rule.enabled = resultObj.missCardEnabled
                            break
                        case 'earlyLeave':
                            rule.count = resultObj.earlyLeaveCount || 0
                            rule.score = resultObj.earlyLeaveScore || 0
                            rule.indexId = resultObj.earlyLeaveIndex || ''
                            rule.indexLabel = resultObj.earlyLeaveIndexLabel || ''
                            rule.enabled = resultObj.earlyLeaveEnabled
                            break
                        case 'absent':
                            rule.count = resultObj.absentCount || 0
                            rule.score = resultObj.absentScore || 0
                            rule.indexId = resultObj.absentIndex || ''
                            rule.indexLabel = resultObj.absentIndexLabel || ''
                            rule.enabled = resultObj.absentEnabled
                            break
                        case 'late':
                            rule.count = resultObj.lateCount || 0
                            rule.score = resultObj.lateScore || 0
                            rule.indexId = resultObj.lateIndex || ''
                            rule.indexLabel = resultObj.lateIndexLabel || ''
                            rule.enabled = resultObj.lateEnabled
                            break
                    }
                });
            },
            //获取考评组织列表
            getOrganizes(){
                let url = this.getDeptCascaderUrl
                let data = {
                    deptId: this.form.deptId
                };
                this.organizes = []
                this.apiPost(url, data).then(
                    (res) => {
                        if (res.status == 200) {
                            this.organizes = res.data.selects
                            console.log('organizeId前：', this.form.organizeId)
                            this.form.organizeId = this.getName(this.form.organizeId,this.organizes)
                            console.log('organizeId后：', this.form.organizeId)
                        } else {
                            this.$commonFn.showTip(res.message, 3);
                        }
                    },(err) => {
                        console.log(err);
                    }
                );
            },
            // 清空配置
            clearConfig(){
                MessageBox.confirm('确定要清空配置吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.clear();
                    this.save();
                }).catch(() => {
                    this.$commonFn.showTip('已取消清空',1);
                });
            },
            // 清空数据
            clear(){
                this.form.attendanceSwitch = false
                this.form.organizeId = "" // 组织ID
                this.form.lastStartDate = "" // 上学期开始日期
                this.form.lastEndDate = "" // 上学期结束日期
                this.form.nextStartDate = "" // 下学期开始日期
                this.form.nextEndDate = "" // 下学期结束日期
                this.form.calculateTime = "" // 计算考勤时间
                this.form.calculateDay = "" // 计算考勤日期

                // 减分规则
                this.form.leaveCount = "" // 事假次数
                this.form.leaveScore = "" // 事假扣分
                this.form.leaveIndex = ""
                this.form.leaveIndexLabel = ""
                this.form.leaveEnabled = false
                this.form.sickLeaveCount = "" // 病假次数
                this.form.sickLeaveScore = "" // 病假扣分
                this.form.sickLeaveIndex = ""
                this.form.sickLeaveIndexLabel = ""
                this.form.sickLeaveEnabled = false
                this.form.missCardCount = "" // 缺卡次数
                this.form.missCardScore = "" // 缺卡扣分
                this.form.missCardIndex = ""
                this.form.missCardIndexLabel = ""
                this.form.missCardEnabled = false
                this.form.earlyLeaveCount = "" // 早退次数
                this.form.earlyLeaveScore = "" // 早退扣分
                this.form.earlyLeaveIndex = ""
                this.form.earlyLeaveIndexLabel = ""
                this.form.earlyLeaveEnabled = false
                this.form.absentCount = "" // 旷工次数
                this.form.absentScore = "" // 旷工扣分
                this.form.absentIndex = ""
                this.form.absentIndexLabel = ""
                this.form.absentEnabled = false
                this.form.lateCount = "" // 迟到次数
                this.form.lateScore = "" // 迟到扣分
                this.form.lateIndex = ""
                this.form.lateIndexLabel = ""
                this.form.lateEnabled = false
                
                // 重置表格数据
                this.attendanceRules.forEach(rule => {
                    rule.count = 1
                    rule.score = 1
                    rule.indexId = ""
                    rule.indexLabel = ""
                    rule.enabled = false
                });
            },
            // 保存
            async save(){
                // 从表格数据更新到表单数据
                this.syncTableDataToForm();
                // 启用钉钉考勤，需进行表单校验
                if(this.form.attendanceSwitch){
                    const valid = await this.$refs['form'].validate();
                    if(!valid) return

                    // 考评日期范围校验
                    if(this.$util.isEmpty(this.form.lastStartDate) 
                            || this.$util.isEmpty(this.form.lastEndDate)){
                        this.$commonFn.showTip('上学期开始日期或者结束日期不可为空', 3)
                        return
                    }
                    if(this.$util.isEmpty(this.form.nextStartDate) 
                            || this.$util.isEmpty(this.form.nextEndDate)){
                        this.$commonFn.showTip('下学期开始日期或者结束日期不可为空', 3)
                        return
                    }
                    // 计算考勤日期校验
                    if(this.$util.isEmpty(this.form.calculateDay)){
                        this.$commonFn.showTip('计算考勤和推送时间设置日不可为空', 3)
                        return
                    }
                    // 钉钉考勤减分规则校验
                    if(this.form.leaveEnabled){
                        // 事假
                        if(this.$util.isEmpty(this.form.leaveCount) 
                            || this.$util.isEmpty(this.form.leaveScore)){
                            this.$commonFn.showTip('事假次数或者扣分不可为空', 3)
                            return  
                        }

                        if(this.$util.isEmpty(this.form.leaveIndex)){
                            this.$commonFn.showTip('事假指标不可为空', 3)
                            return
                        }
                    }
                    if(this.form.sickLeaveEnabled){
                        // 病假
                        if(this.$util.isEmpty(this.form.sickLeaveCount) 
                            || this.$util.isEmpty(this.form.sickLeaveScore)){
                            this.$commonFn.showTip('病假次数或者扣分不可为空', 3)
                            return  
                        }

                        if(this.$util.isEmpty(this.form.sickLeaveIndex)){
                            this.$commonFn.showTip('病假指标不可为空', 3)
                            return
                        }
                    }
                    if(this.form.missCardEnabled){
                        // 缺卡
                        if(this.$util.isEmpty(this.form.missCardCount) 
                            || this.$util.isEmpty(this.form.missCardScore)){
                            this.$commonFn.showTip('缺卡次数或者扣分不可为空', 3)
                            return  
                        }

                        if(this.$util.isEmpty(this.form.missCardIndex)){
                            this.$commonFn.showTip('缺卡指标不可为空', 3)
                            return
                        }
                    }
                    if(this.form.earlyLeaveEnabled){
                        // 早退
                        if(this.$util.isEmpty(this.form.earlyLeaveCount) 
                            || this.$util.isEmpty(this.form.earlyLeaveScore)){
                            this.$commonFn.showTip('早退次数或者扣分不可为空', 3)
                            return  
                        }

                        if(this.$util.isEmpty(this.form.earlyLeaveIndex)){
                            this.$commonFn.showTip('早退指标不可为空', 3)
                            return
                        }
                    }
                    if(this.form.absentEnabled){
                        // 旷工
                        if(this.$util.isEmpty(this.form.absentCount) 
                            || this.$util.isEmpty(this.form.absentScore)){
                            this.$commonFn.showTip('旷工次数或者扣分不可为空', 3)
                            return  
                        }

                        if(this.$util.isEmpty(this.form.absentIndex)){
                            this.$commonFn.showTip('旷工指标不可为空', 3)
                            return
                        }
                    }
                    if(this.form.lateEnabled){
                        // 迟到
                        if(this.$util.isEmpty(this.form.lateCount) 
                            || this.$util.isEmpty(this.form.lateScore)){
                            this.$commonFn.showTip('迟到次数或者扣分不可为空', 3)
                            return  
                        }

                        if(this.$util.isEmpty(this.form.lateIndex)){
                            this.$commonFn.showTip('迟到指标不可为空', 3)
                            return
                        }
                    }
                }
                
                
                let reqObj = {
                    evaluate_switch_key: this.form.attendanceSwitch ? 1 : 0,
                    evaluate_dept_key: this.form.organizeId[this.form.organizeId.length-1],
                    evaluate_dateRange_key: {
                        lastStartDate: this.form.lastStartDate,
                        lastEndDate: this.form.lastEndDate,
                        nextStartDate: this.form.nextStartDate,
                        nextEndDate: this.form.nextEndDate
                    },
                    calculate_time_key: {
                        calculateDay: this.form.calculateDay,
                        calculateTime: this.form.calculateTime
                    },
                    rule_config_key: {
                        leaveCount: this.form.leaveCount,
                        leaveScore: this.form.leaveScore,
                        leaveIndex: this.form.leaveIndex,
                        leaveIndexLabel: this.form.leaveIndexLabel,
                        leaveEnabled: this.form.leaveEnabled,
                        sickLeaveCount: this.form.sickLeaveCount,
                        sickLeaveScore: this.form.sickLeaveScore,
                        sickLeaveIndex: this.form.sickLeaveIndex,
                        sickLeaveIndexLabel: this.form.sickLeaveIndexLabel,
                        sickLeaveEnabled: this.form.sickLeaveEnabled,
                        missCardCount: this.form.missCardCount,
                        missCardScore: this.form.missCardScore,
                        missCardIndex: this.form.missCardIndex,
                        missCardIndexLabel: this.form.missCardIndexLabel,
                        missCardEnabled: this.form.missCardEnabled,
                        earlyLeaveCount: this.form.earlyLeaveCount,
                        earlyLeaveScore: this.form.earlyLeaveScore,
                        earlyLeaveIndex: this.form.earlyLeaveIndex,
                        earlyLeaveIndexLabel: this.form.earlyLeaveIndexLabel,
                        earlyLeaveEnabled: this.form.earlyLeaveEnabled,
                        absentCount: this.form.absentCount,
                        absentScore: this.form.absentScore,
                        absentIndex: this.form.absentIndex,
                        absentIndexLabel: this.form.absentIndexLabel,
                        absentEnabled: this.form.absentEnabled,
                        lateCount: this.form.lateCount,
                        lateScore: this.form.lateScore,
                        lateIndex: this.form.lateIndex,
                        lateIndexLabel: this.form.lateIndexLabel,
                        lateEnabled: this.form.lateEnabled
                    }
                }
                
                let data = {
                    'deptId':this.form.deptId,
                    'data':JSON.stringify(reqObj)
                }
                // console.log(JSON.stringify(data))
                // return
                this.loading = true
                let url = this.teacherDingtalkAttendanceEvaluateSetSaveUrl
                this.apiPost(url, data).then(
                    (res) => {
                        this.loading = false
                        if (res.status == 200) {
                            this.$commonFn.showTip('保存成功', 1)
                        } else {
                            this.$commonFn.showTip(res.message, 3)
                        }
                    },
                    (err) => {
                        this.loading = false
                        console.log(err)
                    }
                );
            },
            // 从表格数据同步到表单数据
            syncTableDataToForm() {
                this.attendanceRules.forEach(rule => {
                    // if (!rule.enabled) {
                    //     return; // 如果规则未启用，跳过
                    // }
                    
                    switch(rule.key) {
                        case 'leave':
                            this.form.leaveCount = rule.count
                            this.form.leaveScore = rule.score
                            this.form.leaveIndex = rule.indexId
                            this.form.leaveIndexLabel = rule.indexLabel
                            this.form.leaveEnabled = rule.enabled
                            break;
                        case 'sickLeave':
                            this.form.sickLeaveCount = rule.count
                            this.form.sickLeaveScore = rule.score
                            this.form.sickLeaveIndex = rule.indexId
                            this.form.sickLeaveIndexLabel = rule.indexLabel
                            this.form.sickLeaveEnabled = rule.enabled
                            break;
                        case 'missCard':
                            this.form.missCardCount = rule.count
                            this.form.missCardScore = rule.score
                            this.form.missCardIndex = rule.indexId
                            this.form.missCardIndexLabel = rule.indexLabel
                            this.form.missCardEnabled = rule.enabled
                            break;
                        case 'earlyLeave':
                            this.form.earlyLeaveCount = rule.count
                            this.form.earlyLeaveScore = rule.score
                            this.form.earlyLeaveIndex = rule.indexId
                            this.form.earlyLeaveIndexLabel = rule.indexLabel
                            this.form.earlyLeaveEnabled = rule.enabled
                            break;
                        case 'absent':
                            this.form.absentCount = rule.count
                            this.form.absentScore = rule.score
                            this.form.absentIndex = rule.indexId
                            this.form.absentIndexLabel = rule.indexLabel
                            this.form.absentEnabled = rule.enabled
                            break;
                        case 'late':
                            this.form.lateCount = rule.count
                            this.form.lateScore = rule.score
                            this.form.lateIndex = rule.indexId
                            this.form.lateIndexLabel = rule.indexLabel
                            this.form.lateEnabled = rule.enabled
                            break;
                    }
                });
            },
            // 考评组织
            getName(setVal,data){
                if(this.$util.isNotEmpty(data)){
                   let valArr = setVal.split(",");
                   let arr = new Array();
                   for(let i = 0;i < valArr.length;i++){
                       let tempArr = new Array();
                       this.recursionCascader(valArr[i], data, tempArr, data);
                       arr.push(tempArr.reverse());
                   }
                   return arr[0];
                }
            },
            recursionCascader(val, cdata, tempArr, data){
                if(val == 0){
                    return;
                }
                // 递归获取值
                for(var i=0; i<cdata.length;i++){
                   if(cdata[i].value == val){
                       tempArr.push(val);
                       this.recursionCascader(cdata[i].parentId, data, tempArr, data);
                   }
                   if(cdata[i].children && cdata[i].children.length) {
                       this.recursionCascader(val, cdata[i].children, tempArr, data);
                   }
                }
            },
        },
        mixins: [http]
    }
</script>

<style scoped>
.container {
    margin: 0 auto;
    padding: 20px;
}

.el-divider {
    margin: 20px 0;
}

.info-tip {
    position: absolute;
    right: 20px;
    margin-top: -40px;
}

.info-tip i {
    color: #909399;
    cursor: pointer;
}

.el-table {
    margin-bottom: 20px;
}

.el-table .el-switch {
    margin-left: 10px;
}

.dialog-footer {
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/dingdingAttendance/list.vue